// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b677bbe2","732":"983eaab7","977":"4eeae155"}[chunkId] + ".chunk.js";
};